export const onMobile = `@media screen and (max-width: 767px)`
export const onDesktop = `@media screen and (min-width: 768px)`
export const onMassiveScreen = `@media screen and (min-width: 1440px)`
